var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillSet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.709,
    height: 35.675,
    viewBox: "0 0 35.709 35.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49661",
    "data-name": "Group 49661",
    transform: "translate(-4508.337 -371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49660",
    "data-name": "Group 49660",
    transform: "translate(4508.337 371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93398",
    "data-name": "Path 93398",
    d: "M42.158,39.633A.892.892,0,0,0,43.63,39.3a7.127,7.127,0,0,0-8.028-9.4l-3.69-3.69,9.757-9.757a3.574,3.574,0,0,0,0-5.049l-.676-.676a3.574,3.574,0,0,0-5.049,0l-9.757,9.757-3.7-3.7a7.121,7.121,0,0,0-9.409-8,.892.892,0,0,0-.331,1.471L16.1,13.6l-2.522,2.522-3.35-3.35a.892.892,0,0,0-1.471.331,7.154,7.154,0,0,0,1.664,7.439,7.078,7.078,0,0,0,6.355,1.971l3.69,3.69-9.884,9.884a.893.893,0,0,0-.228.387L8.583,42.7a.892.892,0,0,0,.859,1.136.869.869,0,0,0,.244-.033l6.229-1.766a.883.883,0,0,0,.387-.228l9.884-9.884,3.7,3.7a7.14,7.14,0,0,0,9.416,8,.892.892,0,0,0,.331-1.471L36.274,38.8,38.8,36.276l3.359,3.359ZM15.173,38.478,36.9,16.753l.969.969L15.938,39.651a8.317,8.317,0,0,0-.765-1.173Zm-1.262-1.262a8.317,8.317,0,0,0-1.173-.765L34.667,14.522l.969.969Zm23.3-25.234a1.791,1.791,0,0,1,2.525,0l.676.676a1.789,1.789,0,0,1,0,2.525l-1.277,1.277-3.2-3.2ZM17.687,20.9a.888.888,0,0,0-.857-.233,5.339,5.339,0,0,1-6.7-5.468l2.812,2.812a.918.918,0,0,0,1.262,0l3.784-3.784a.89.89,0,0,0,0-1.262l-2.812-2.812a5.333,5.333,0,0,1,5.466,6.682.9.9,0,0,0,.233.855l4.047,4.047-3.2,3.2-4.037-4.037Zm-5.9,17.055a6.194,6.194,0,0,1,2.646,2.646l-3.692,1.048,1.048-3.692Zm22.6.206a.89.89,0,0,0,0,1.262l2.82,2.82a5.341,5.341,0,0,1-5.474-6.681.9.9,0,0,0-.233-.855l-4.047-4.047,3.2-3.2L34.689,31.5a.9.9,0,0,0,.857.233A5.344,5.344,0,0,1,42.254,37.2l-2.822-2.82a.89.89,0,0,0-1.262,0l-3.784,3.784Z",
    transform: "translate(-8.337 -8.364)",
    fill: "#0c66e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93399",
    "data-name": "Path 93399",
    d: "M78.806,35.832a.9.9,0,0,0-.825.551A2.887,2.887,0,0,1,75.965,38.4a.893.893,0,0,0,0,1.65,2.887,2.887,0,0,1,2.017,2.017.893.893,0,0,0,1.65,0,2.887,2.887,0,0,1,2.017-2.017.893.893,0,0,0,0-1.65,2.887,2.887,0,0,1-2.017-2.017A.894.894,0,0,0,78.806,35.832Zm0,4.038a3.632,3.632,0,0,0-.646-.646,3.631,3.631,0,0,0,.646-.646,3.631,3.631,0,0,0,.646.646A3.631,3.631,0,0,0,78.806,39.87Z",
    transform: "translate(-46.676 -24.064)",
    fill: "#0c66e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93400",
    "data-name": "Path 93400",
    d: "M9.3,52.55a2.887,2.887,0,0,1,2.017,2.017.893.893,0,0,0,1.65,0,2.887,2.887,0,0,1,2.017-2.017.893.893,0,0,0,0-1.65,2.887,2.887,0,0,1-2.017-2.017.893.893,0,0,0-1.65,0A2.887,2.887,0,0,1,9.3,50.9a.893.893,0,0,0,0,1.65Zm2.842-1.471a3.631,3.631,0,0,0,.646.646,3.631,3.631,0,0,0-.646.646,3.631,3.631,0,0,0-.646-.646A3.631,3.631,0,0,0,12.142,51.079Z",
    transform: "translate(-8.573 -31.208)",
    fill: "#0c66e4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillSet);
export default __webpack_public_path__ + "static/media/skill-set.718db284a2432be9d2ac84b1d92f43b1.svg";
export { ForwardRef as ReactComponent };